import axios from 'axios';
import { setError } from './action/error';
import store from '../store/store';

let notFoundErrorMessage = 'برای درخواست شما نتیجه ای یافت نشد.';
let fiveHundredErrorMessage = 'متاسفانه در این لحظه خطایی رخ داده است، لطفا کمی بعد مجددا تلاش کنید';
let nounStatusErrorMessage = 'متاسفانه در این لحظه خطایی رخ داده است، لطفا کمی بعد مجددا تلاش کنید';
let authorizationErrorMessage = 'عدم دسترسی';
let tokenExpiresMessage = 'توکن شما منقضی شده است';

let axiosInstance = axios.create({
  baseURL: process.env.REACT_APP_DISCOVERY_URL,
});

axiosInstance.interceptors.request.use(config => {
  // let organizationKey = store.getState().permission?.selectedOrg?.organization_key;
  let roleId = store.getState().permission?.selectedRole?.id;
  //for all requests send org key except notification request
  if (!config.url.startsWith(process.env.REACT_APP_NOTIFICATION_URL)) {
    // if (organizationKey) config.headers['current-organization-key'] = organizationKey;
    if (roleId) config.headers['current-role-id'] = roleId;
  }

  return config;
});

axiosInstance.interceptors.response.use(
  response => response,
  function(error) {
    handleErrors(error);
    return Promise.reject(error);
  }
);

function handleErrors(error) {
  function handleNonFieldErrors(errorData) {
    if (errorData.non_field_errors) {
      errorData.non_field_errors.forEach(item => store.dispatch(setError(item)));
    }
  }

  function handle403Errors(errorData) {
    if (Boolean(errorData.detail)) {
      store.dispatch(setError(errorData.detail));
    } else {
      store.dispatch(setError(authorizationErrorMessage));
    }

    window.location.replace(window.location.origin);

    // localStorage.removeItem('permission');
    // window.location.reload();
  }

  if (Boolean(error.response)) {
    switch (error.response.status) {
      case 400:
        handleNonFieldErrors(error.response.data);
        break;
      case 404:
        store.dispatch(setError(notFoundErrorMessage));
        break;
      case 403:
        handle403Errors(error.response.data);
        break;
      case 401:
        store.dispatch(setError(tokenExpiresMessage));
        window.location.replace(`${process.env.REACT_APP_MARKETING_URL}/user/before-login`);
        break;
      case 500:
        store.dispatch(setError(fiveHundredErrorMessage));
        break;
      default:
        store.dispatch(setError(nounStatusErrorMessage));
    }
  }
}

export default axiosInstance;
